module.exports = __webpack_public_path__ + "img/footer-1.2559c41c.png";